export default class Feature {
    /**
     * @param {object} features
     */
    static set(features) {
        this.features = features;
    }

    /**
     * @param {string} featureName
     * @returns {boolean}
     */
    static isEnabled(featureName) {
        // Feature values can be falsy : null, false, 0, empty string or "disabled" (on legacy ToggleFeature)
        return (
            this.features.hasOwnProperty(featureName) &&
            this.features[featureName] !== 'disabled' &&
            Boolean(this.features[featureName])
        );
    }

    /**
     * @param {string} featureName
     * @param {string} variationName
     * @returns {boolean}
     */
    static isVariation(featureName, variationName) {
        return this.isEnabled(featureName) && this.features[featureName] === variationName;
    }
}
